Barba.Dispatcher.on('transitionCompleted', function() {
	$(window).on('resize', function(){
		var footerheight = $(".footer").height();
		var container = document.getElementsByClassName("barba-container");
		container[0].style.paddingBottom = footerheight+"px"; // set padding bottom to height of footer
	}).resize();
});